/**
 * Datas no horário de Brasília (o fuso do portal), sem depender do fuso de
 * quem está no navegador: a intranet é lida de DSEIs em quatro fusos, e a
 * data de um evento tem de ser a mesma para todos.
 */

export const FUSO = 'America/Sao_Paulo';

const DATA_PURA = /^(\d{4})-(\d{2})-(\d{2})$/;
const dois = (n) => String(n).padStart(2, '0');

const partesEm = (instante) => {
  const partes = new Intl.DateTimeFormat('en-US', {
    timeZone: FUSO,
    hourCycle: 'h23',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).formatToParts(instante);
  const v = Object.fromEntries(partes.map((p) => [p.type, p.value]));
  return {
    ano: Number(v.year),
    mes: Number(v.month),
    dia: Number(v.day),
    hora: Number(v.hour) % 24,
    minuto: Number(v.minute),
    segundo: Number(v.second),
  };
};

/** Minutos entre o horário de Brasília e o UTC naquele instante (-180). */
export const deslocamento = (instante) => {
  const p = partesEm(instante);
  const comoUtc = Date.UTC(
    p.ano,
    p.mes - 1,
    p.dia,
    p.hora,
    p.minuto,
    p.segundo,
  );
  const semMs = Math.floor(instante.getTime() / 1000) * 1000;
  return Math.round((comoUtc - semMs) / 60000);
};

/** "AAAA-MM-DD" do valor no horário de Brasília; data pura passa como está. */
export const dataEmBrasilia = (valor) => {
  if (!valor) return null;
  if (DATA_PURA.test(valor)) return valor;
  const d = new Date(valor);
  if (Number.isNaN(d.getTime())) return null;
  const p = partesEm(d);
  return `${p.ano}-${dois(p.mes)}-${dois(p.dia)}`;
};

/** A meia-noite de Brasília daquele dia: "2026-10-23T00:00:00-03:00". */
export const meiaNoiteEmBrasilia = (data) => {
  const m = DATA_PURA.exec(data || '');
  if (!m) return data;
  const base = Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  // o deslocamento de verdade é o da meia-noite local (vale num dia de
  // mudança de horário, se o Brasil voltar a ter horário de verão)
  let off = deslocamento(new Date(base));
  off = deslocamento(new Date(base - off * 60000));
  const a = Math.abs(off);
  const sinal = off < 0 ? '-' : '+';
  return `${m[1]}-${m[2]}-${m[3]}T00:00:00${sinal}${dois(Math.floor(a / 60))}:${dois(a % 60)}`;
};

/** O instante da meia-noite de Brasília, `dias` dias depois do de `instante`. */
export const inicioDoDia = (instante, dias = 0) => {
  const [a, m, d] = dataEmBrasilia(instante.toISOString())
    .split('-')
    .map(Number);
  const alvo = new Date(Date.UTC(a, m - 1, d + dias))
    .toISOString()
    .slice(0, 10);
  return new Date(meiaNoiteEmBrasilia(alvo));
};

/** Formata no horário de Brasília, em português. */
export const formatar = (valor, opcoes) =>
  new Intl.DateTimeFormat('pt-BR', { timeZone: FUSO, ...opcoes }).format(
    DATA_PURA.test(valor || '')
      ? new Date(meiaNoiteEmBrasilia(valor))
      : new Date(valor),
  );
